const validate = (value, t, unit) => {
	if (Number.isNaN(Number(value)) || Number(value) === 0) {
		return {
			isValid: false,
			errorMessages: [t('pages.step1.settingsArea.roomsInvalid', { unit })],
			label: t('pages.step1.settingsArea.amountRooms', {
				unit
			}),
			showErrorMessage: true
		};
	}

	return {
		isValid: true
	};
};

export default validate;
